import React from "react";
import { Menu, X } from "lucide-react";

export default function Header() {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (open) document.body.classList.add("overflow-hidden");
    else document.body.classList.remove("overflow-hidden");
    return () => document.body.classList.remove("overflow-hidden");
  }, [open]);

  const NavLinks: React.FC<{ onItemClick?: () => void }> = ({ onItemClick }) => (
    <>
      <a href="#features" onClick={onItemClick} className="text-neutral-300 transition-colors hover:text-indigo-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/60 rounded-sm">Features</a>
      <a href="#quickstart" onClick={onItemClick} className="text-neutral-300 transition-colors hover:text-indigo-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/60 rounded-sm">Quickstart</a>
      <a href="#use-cases" onClick={onItemClick} className="text-neutral-300 transition-colors hover:text-indigo-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/60 rounded-sm">Use Cases</a>
      <a href="#pricing" onClick={onItemClick} className="text-neutral-300 transition-colors hover:text-indigo-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/60 rounded-sm">Pricing</a>
      <a href="/docs/" onClick={onItemClick} className="text-neutral-300 transition-colors hover:text-indigo-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500/60 rounded-sm">Documentation</a>
    </>
  );

  return (
    <header className="sticky top-0 z-40 w-full border-b border-neutral-800 bg-neutral-950/70 backdrop-blur relative from-top" style={{ ['--reveal-delay' as any]: '420ms', ['--reveal-distance' as any]: '64px', ['--reveal-duration' as any]: '1100ms', ['--reveal-ease' as any]: 'cubic-bezier(0.16, 1, 0.3, 1)' }}>
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 md:gap-2 md:px-4 lg:px-6 2xl:px-8">
        <a href="/" className="inline-flex items-center gap-3">
          <img src="/assets/payme-sol-logo.png" alt="Payme.sol" className="h-8 w-auto md:h-7 lg:h-9 2xl:h-10" />
        </a>

        <nav className="hidden items-center gap-3 lg:flex lg:gap-5 2xl:gap-7">
          <div className="flex items-center gap-3 lg:gap-5 2xl:gap-7 [&_a]:text-[12px] [&_a]:md:text-[13px] [&_a]:lg:text-sm [&_a]:2xl:text-base">
            <NavLinks />
          </div>
        </nav>

        <div className="hidden items-center gap-2 lg:flex lg:gap-3 2xl:gap-4">
          <a
            href="https://basic.paymesol.app"
            target="_blank"
            rel="noreferrer noopener"
            className="rounded-md border border-neutral-700 px-3 py-2 text-[13px] font-medium text-white hover:bg-neutral-800 md:px-3 md:text-sm lg:px-4 2xl:px-5 2xl:py-2.5 2xl:text-base"
          >
            Open Basic
          </a>
          <a
            href="https://pro.paymesol.app"
            target="_blank"
            rel="noreferrer noopener"
            className="rounded-md bg-indigo-600 px-3 py-2 text-[13px] font-medium text-white hover:bg-indigo-500 md:px-3 md:text-sm lg:px-4 2xl:px-5 2xl:py-2.5 2xl:text-base"
          >
            Open Pro
          </a>
        </div>

        <button
          className="inline-flex items-center rounded-md border border-neutral-800 p-2 text-neutral-200 lg:hidden"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X className="size-5" /> : <Menu className="size-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden absolute inset-x-0 top-full ps-slide-down">
          <div className="border-t border-neutral-800 bg-neutral-950/95 px-4 py-4 shadow-xl shadow-black/40">
            <div className="flex flex-col gap-3">
              <NavLinks onItemClick={() => setOpen(false)} />
              <div className="mt-2 grid grid-cols-2 gap-2">
                <a
                  href="https://basic.paymesol.app"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="inline-flex items-center justify-center rounded-md border border-neutral-700 px-4 py-2 text-sm font-medium text-white hover:bg-neutral-800"
                  onClick={() => setOpen(false)}
                >
                  Open Basic
                </a>
                <a
                  href="https://pro.paymesol.app"
                  target="_blank"
                  rel="noreferrer noopener"
                  className="inline-flex items-center justify-center rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white hover:bg-indigo-500"
                  onClick={() => setOpen(false)}
                >
                  Open Pro
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
